import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COMMON } from "@store/theme/design";
import { gridGapStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export interface StoreBaseGridProps {
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumn?: GridItemProps;
}

export interface StoreBaseGridItemGridProps {
    container?: GridContainerProps;
    item?: GridItemProps;
}

export const baseGridStyles = (verticalGap?: Array<string | 0 | null> | null) => {
    const _horizontalGap = [null, "30px", "45px", null, "80px"];
    const _verticalGap = verticalGap?.slice(0, 2) || COMMON.spacing.content.slice(0, 2);

    return css`
        ${gridGapStyles(_horizontalGap, _verticalGap)}
    `;
};

export const baseGridProps: StoreBaseGridProps = {
    container: {
        gap: 0,
        css: css`
            ${baseGridStyles()}
        `,
    },
    sideColumn: {
        width: [12, 12, 4, 3, 3],
        css: css`
            display: block;
        `,
    },
    mainColumn: {
        width: [12, 12, 8, 9, 9],
        css: css`
            display: block;
        `,
    },
};

export const baseGridHiddenProps: StoreBaseGridProps = {
    container: {
        ...baseGridProps.container,
        css: css`
            ${baseGridStyles([])}
        `,
    },
    sideColumn: {
        ...baseGridProps.sideColumn,
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    mainColumn: baseGridProps.mainColumn,
};

export const baseGridItemGridProps: StoreBaseGridItemGridProps = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles(["20px", "25px", "30px"])}
        `,
    },
    item: {
        width: [12, 6, 6, 4, 4],
    },
};
